import { PageActions, PageTitle } from "../layout/PageActions";
import { DashboardStepper } from "./DashboardStepper";
import { useOnboardingState } from "./useOnboardingState";
import { DashboardHomeContent } from "@/modules/dashboard/DashboardHomeContent";
import { useSearchParams } from "react-router";
import { ViewTabs } from "@/modules/shared/chrome";
import { TeamMapView } from "@/modules/teamMap/TeamMapView";

type DashboardView = "overview" | "team-map";

const DASHBOARD_TABS: { value: DashboardView; label: string }[] = [
  { value: "overview", label: "Overview" },
  { value: "team-map", label: "Team Map" },
];

export const Dashboard = () => {
  const { totalContact, totalContactNotes, firstContactId, isPending } =
    useOnboardingState();
  const [searchParams, setSearchParams] = useSearchParams();
  const view: DashboardView =
    searchParams.get("view") === "team-map" ? "team-map" : "overview";
  const setView = (next: DashboardView) => {
    const params = new URLSearchParams(searchParams);
    if (next === "overview") params.delete("view");
    else params.set("view", next);
    setSearchParams(params, { replace: true });
  };

  if (isPending) {
    return null;
  }

  if (!totalContact) {
    return <DashboardStepper step={1} />;
  }

  if (!totalContactNotes) {
    return <DashboardStepper step={2} contactId={firstContactId} />;
  }

  return (
    <>
      <PageActions>
        <PageTitle label="Dashboard" />
      </PageActions>
      <ViewTabs
        value={view}
        onChange={setView}
        tabs={DASHBOARD_TABS}
        ariaLabel="Dashboard view"
        className="mb-3"
      />
      {view === "team-map" ? <TeamMapView /> : <DashboardHomeContent />}
    </>
  );
};
